import { createKeycloak } from "@dreebit-registry/vsm-microservice-components";

// Realm/URL config is shared across all Otto microservices and resolved from the
// hostname. Must stay a module-level singleton.
const keycloak = createKeycloak();

export default keycloak;
